import { z } from 'zod';
const getMissionNotificationRecipientsByMissionIdParamsSchema = z.object({
    missionId: z.string().uuid(),
});
const getMissionNotificationRecipientsByMissionIdResponseSchema = z.object({
    allQualifiedVolunteers: z.string().uuid().array(),
    pastShiftVolunteers: z.string().uuid().array(),
    upcomingShiftVolunteers: z.string().uuid().array(),
});
export const getMissionNotificationRecipientsByMissionIdFunctionDef = {
    name: 'getMissionNotificationRecipientsByMissionId',
    requestSchema: getMissionNotificationRecipientsByMissionIdParamsSchema,
    responseSchema: getMissionNotificationRecipientsByMissionIdResponseSchema,
};
